// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
  position: absolute;
  white-space: nowrap;
  max-height: 1.4em;
  top: 1.5em;
  right: 0;
  font-weight: 400;
  font-size: 0.9em;
  color: rgba(124, 35, 35, 0.593);
}
.error__date {
  margin-left: 0;
}
.error__hidden {
  z-index: -1000;
  margin-top: -4px;
}
.error_dateInp {
  top: 2em;
}

input {
  color: #426ba6;
  padding: 1px 0.5em;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #e2e2e2;
  font-style: italic;
  font-weight: 400;
}
input::placeholder {
  color: #a3b9d9;
}
input:focus {
  outline: none;
  border-bottom: 1px solid rgba(29, 38, 82, 0.3921568627);
}

.country_btn {
  border: 0;
  background: transparent;
}
.country_btn:hover {
  background: transparent;
}

.project_input {
  display: flex;
  align-items: flex-start;
  justify-content: left;
  padding-top: 5px;
  position: relative;
}
.project_input.phoneInput .form-control {
  height: 1.3em;
  font-size: 1rem;
}
.project_input .react-tel-input .flag-dropdown {
  border: 0;
}
.project_input .react-tel-input .flag-dropdown:hover {
  background: transparent;
}
.project_input .inputSelect {
  position: absolute;
  list-style: none;
  padding: 0;
  background-color: rgba(255, 255, 255, 0.9215686275);
  border: 1px solid #a3b9d9;
  z-index: 2;
  max-height: 500px;
  max-width: 300px;
  overflow: auto;
}
.project_input .inputSelect li {
  padding: 5px;
  width: 150px;
}
.project_input .inputSelect li:hover {
  background-color: rgba(214, 223, 234, 0.5764705882);
  cursor: pointer;
}
.project_input label {
  text-align: left;
  min-width: 7em;
}
.project_input input {
  width: 100%;
  height: 1.3em;
  font-size: 1em;
  box-sizing: border-box;
  padding-left: 0.5em;
}
.project_input .select__list_button {
  cursor: pointer;
}
.project_input .select__list_container {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  z-index: 300;
}
.project_input .select__list {
  position: absolute;
  background: rgb(255, 255, 255);
  opacity: 100%;
  border: 1px solid #8aa1c1;
  width: max-content;
  min-width: 100%;
  right: 0;
  top: 1.1em;
  padding: 0 0;
  z-index: 300;
  box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;
  outline: none;
}
.project_input .select__list .optionListHeader {
  padding: 5px 0;
  text-align: center;
  cursor: default;
}
.project_input .select__list .optionListHeader:hover {
  background-color: transparent;
}
.project_input .select__list ul {
  background-color: #fff;
  margin: 0 0;
  max-height: 12em;
  overflow-y: auto;
  overflow-x: hidden;
  list-style: none;
  padding: 0 0;
  text-align: left;
  padding-bottom: 0.8em;
  padding-top: 0.3em;
}
.project_input .select__list ul:focus {
  border: 1px solid #8aa1c1;
  outline: none;
}
.project_input .select__list ul li {
  padding: 0.35em 0;
  padding-right: 0.35em;
  padding-left: 0.3em;
  font-weight: 400;
  border-bottom: 1px solid rgba(71, 74, 78, 0.0941176471);
  cursor: pointer;
}
.project_input .select__list ul li:last-child {
  border-bottom: 0;
}
.project_input .select__list ul li:hover {
  background-color: rgba(138, 161, 193, 0.1176470588);
}
.project_input.textereaInput {
  flex-direction: column;
  margin-top: 0;
  height: 70px;
  width: 100%;
}

.left-drop .select__list {
  right: auto;
  left: 0;
}

.select__list.select__list--above {
  bottom: 14px;
  right: 0;
  top: unset;
}

.selected_option {
  background-color: rgba(66, 108, 166, 0.1843137255);
}

textarea {
  resize: none;
  width: 330px;
  height: 100%;
  border: 1px solid rgba(163, 185, 217, 0.5960784314);
  font-style: italic;
  font-weight: 400;
  font-size: 1rem;
  color: #426ba6;
}
textarea:focus {
  outline: none;
  border: 1px solid rgba(39, 51, 110, 0.4274509804);
}
textarea[readOnly]:focus {
  outline: none;
  border: 1px solid rgba(163, 185, 217, 0.5960784314);
}

.textArea_label {
  margin-bottom: 2px;
  white-space: nowrap;
}

.inputWithMeasureUnits {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.readOnly input:focus {
  outline: none;
  border-bottom: 1px solid #e2e2e2;
}

input[readOnly]:focus {
  outline: none;
  border-bottom: 1px solid #e2e2e2;
}

#questionImg {
  width: 1.2em;
  height: 1.2em;
  z-index: 99;
  display: block;
  position: relative;
}

.question {
  margin-left: 4px;
  position: relative;
  display: inline-block;
}
.question__dropdown {
  position: absolute;
  bottom: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  min-width: 100px;
  min-height: 10px;
  background-color: transparent;
  font-weight: 300;
  margin-left: -45px;
}
.question__dropdown p {
  padding: 0 5px;
  padding-bottom: 10px;
}

.procent {
  display: flex;
  align-items: flex-end;
  justify-content: right;
}
.procent:after {
  content: "%";
}

.price_input {
  display: flex;
  gap: 1em;
  align-items: center;
}

.datePicker_withText {
  position: relative;
  display: flex;
  height: 1.5em;
}
.datePicker_withText input {
  color: #426ba6;
  z-index: 2;
  position: relative;
  padding: 0;
  background-color: rgba(255, 255, 255, 0);
}
.datePicker_withText input[type=date]::-webkit-calendar-picker-indicator {
  opacity: 0;
}
.datePicker_withText .datePicker_img {
  top: -0.3em;
  right: -0.4em;
  z-index: 99;
  cursor: pointer;
  position: absolute;
}

.question-date {
  left: -1.5em;
  top: 0;
  z-index: 99;
  cursor: pointer;
  position: relative;
}

.miniLabel label {
  width: 10px;
}

.additional_inputs {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1em;
}
.additional_inputs .project_input {
  min-width: 50px;
}
.additional_inputs label {
  width: auto;
}

.closeInput label {
  width: auto;
  margin-right: 0.5em;
}

.question__dropdown {
  font-size: smaller;
}

input[type=checkbox] {
  width: 1.2em;
  height: 1.2em;
}

.doc__input_selected {
  border-bottom: 1px solid rgba(29, 38, 82, 0.3921568627);
}

.selectedFormRef .ref_input {
  border-bottom: 1px solid rgba(29, 38, 82, 0.3921568627);
}

.autolabel .project_input label {
  min-width: auto;
  width: auto;
}

.project_input label.autolabel {
  min-width: auto;
  width: auto;
}

.leftLebel .error {
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/Components/Inputs/utils/Inputs.scss","webpack://./src/Components/App/vars.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EAEA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;AAHF;AAIE;EACE,cAAA;AAFJ;AAIE;EACE,cAAA;EACA,gBAAA;AAFJ;AAIE;EACE,QAAA;AAFJ;;AAMA;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AAHF;AAIE;EACE,cC9Be;AD4BnB;AAIE;EACE,aAAA;EACA,uDAAA;AAFJ;;AAKA;EACE,SAAA;EACA,uBAAA;AAFF;AAGE;EAEE,uBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAHF;AAMI;EACE,aAAA;EACA,eAAA;AAJN;AAQE;EACE,SAAA;AANJ;AAOI;EAEE,uBAAA;AANN;AAUE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,mDC5DiB;ED6DjB,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AARJ;AAUI;EACE,YAAA;EACA,YAAA;AARN;AAUM;EACE,mDCvEkB;EDwElB,eAAA;AARR;AAaE;EACE,gBAAA;EAIA,cAAA;AAdJ;AAiBE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AAfJ;AAmBI;EACE,eAAA;AAjBN;AAmBI;EAEE,WAAA;EAEA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AAnBN;AAqBI;EACE,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,yBAAA;EAEA,kBAAA;EACA,eAAA;EACA,QAAA;EAEA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iFAAA;EACA,aAAA;AArBN;AAsBM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AApBR;AAsBQ;EACE,6BAAA;AApBV;AAuBM;EACE,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AArBR;AAsBQ;EACE,yBAAA;EACA,aAAA;AApBV;AAsBQ;EACE,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,uDAAA;EACA,eAAA;AArBV;AAsBU;EACE,gBAAA;AApBZ;AAsBU;EAEE,mDAAA;AArBZ;AA4BE;EACE,sBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AA1BJ;;AA8BE;EACE,WAAA;EACA,OAAA;AA3BJ;;AA8BA;EACE,YAAA;EACA,QAAA;EACA,UAAA;AA3BF;;AA6BA;EACE,kDAAA;AA1BF;;AA4BA;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAGA,cAAA;AA3BF;AA4BE;EACE,aAAA;EACA,iDAAA;AA1BJ;AA6BI;EACE,aAAA;EACA,mDAAA;AA3BN;;AA+BA;EACE,kBAAA;EACA,mBAAA;AA5BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AA3BF;;AAgCI;EACE,aAAA;EACA,gCAAA;AA7BN;;AAkCE;EACE,aAAA;EACA,gCAAA;AA/BJ;;AAmCA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAhCF;;AAkCA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;AA/BF;AAiCE;EACE,kBAAA;EACA,YAAA;EAEA,4BAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AAhCJ;AAiCI;EACE,cAAA;EACA,oBAAA;AA/BN;;AAoCA;EACE,aAAA;EACA,qBAAA;EACA,sBAAA;AAjCF;AAsCE;EAIE,YAAA;AAvCJ;;AA2CA;EACE,aAAA;EAGA,QAAA;EAEA,mBAAA;AA3CF;;AA8CA;EACE,kBAAA;EACA,aAAA;EAEA,aAAA;AA5CF;AA+CE;EAGE,cAAA;EACA,UAAA;EACA,kBAAA;EAGA,UAAA;EAEA,wCAAA;AAlDJ;AAwDE;EACE,UAAA;AAtDJ;AAyDE;EAEE,WAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAxDJ;;AA4DA;EACE,YAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAzDF;;AA6DE;EACE,WAAA;AA1DJ;;AA6DA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,QAAA;AA1DF;AA4DE;EACE,eAAA;AA1DJ;AA8DE;EACE,WAAA;AA5DJ;;AAgEE;EACE,WAAA;EACA,mBAAA;AA7DJ;;AAgEA;EACE,kBAAA;AA7DF;;AAgEA;EACE,YAAA;EACA,aAAA;AA7DF;;AAgEA;EAEE,uDAAA;AA9DF;;AAqEE;EACE,uDAAA;AAlEJ;;AAuEE;EACE,eAAA;EACA,WAAA;AApEJ;;AAyEE;EACE,eAAA;EACA,WAAA;AAtEJ;;AA0EE;EACE,OAAA;AAvEJ","sourcesContent":["@import \"../../App/vars.scss\";\n\n// $bg-img: url(\"./info.png\");\n.error {\n  position: absolute;\n  // width: 100%;\n  white-space: nowrap;\n  max-height: 1.4em;\n  top: 1.5em;\n  right: 0;\n  font-weight: 400;\n  font-size: 0.9em;\n  color: rgba(124, 35, 35, 0.593);\n  &__date {\n    margin-left: 0;\n  }\n  &__hidden {\n    z-index: -1000;\n    margin-top: -4px;\n  }\n  &_dateInp {\n    top: 2em;\n  }\n}\n\ninput {\n  color: #426ba6;\n  padding: 1px 0.5em;\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid #e2e2e2;\n  font-style: italic;\n  font-weight: 400;\n  &::placeholder {\n    color: $placeholderColor;\n  }\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid #1d265264;\n  }\n}\n.country_btn {\n  border: 0;\n  background: transparent;\n  &:hover {\n    // font-weight: 500;\n    background: transparent;\n  }\n}\n\n.project_input {\n  display: flex;\n  align-items: flex-start;\n  justify-content: left;\n  padding-top: 5px;\n  position: relative;\n\n  &.phoneInput {\n    & .form-control {\n      height: 1.3em;\n      font-size: 1rem;\n    }\n  }\n\n  .react-tel-input .flag-dropdown {\n    border: 0;\n    &:hover {\n      // font-weight: 500;\n      background: transparent;\n    }\n  }\n\n  & .inputSelect {\n    position: absolute;\n    list-style: none;\n    padding: 0;\n    background-color: $inputSelectBgColor;\n    border: 1px solid $borderColor;\n    z-index: 2;\n    max-height: 500px;\n    max-width: 300px;\n    overflow: auto;\n\n    & li {\n      padding: 5px;\n      width: 150px;\n\n      &:hover {\n        background-color: $inputSelectHoverBgColor;\n        cursor: pointer;\n      }\n    }\n  }\n\n  label {\n    text-align: left;\n    // margin-top: 5px;\n    // margin-right: 5px;\n\n    min-width: 7em;\n  }\n\n  input {\n    width: 100%;\n    height: 1.3em;\n    font-size: 1em;\n    box-sizing: border-box;\n    padding-left: 0.5em;\n  }\n\n  .select {\n    &__list_button {\n      cursor: pointer;\n    }\n    &__list_container {\n      // width: 25%;\n      width: 100%;\n      // width: calc(100% + 3em);\n      height: 100%;\n      display: flex;\n      position: absolute;\n      z-index: 300;\n    }\n    &__list {\n      position: absolute;\n      background: rgb(255, 255, 255);\n      opacity: 100%;\n      border: 1px solid #8aa1c1;\n      // min-width: 60%;\n      width: max-content;\n      min-width: 100%;\n      right: 0;\n      // width: calc(100% + 3em);\n      top: 1.1em;\n      padding: 0 0;\n      z-index: 300;\n      box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;\n      outline: none;\n      .optionListHeader {\n        padding: 5px 0;\n        text-align: center;\n        cursor: default;\n\n        &:hover {\n          background-color: transparent;\n        }\n      }\n      ul {\n        background-color: #fff;\n        margin: 0 0;\n        max-height: 12em;\n        overflow-y: auto;\n        overflow-x: hidden;\n        list-style: none;\n        padding: 0 0;\n        text-align: left;\n        padding-bottom: 0.8em;\n        padding-top: 0.3em;\n        &:focus {\n          border: 1px solid #8aa1c1;\n          outline: none;\n        }\n        li {\n          padding: 0.35em 0;\n          padding-right: 0.35em;\n          padding-left: 0.3em;\n          font-weight: 400;\n          // margin-top: 0.3em;\n          border-bottom: 1px solid #474a4e18;\n          cursor: pointer;\n          &:last-child {\n            border-bottom: 0;\n          }\n          &:hover {\n            // font-weight: 500;\n            background-color: #8aa1c11e;\n          }\n        }\n      }\n    }\n  }\n\n  &.textereaInput {\n    flex-direction: column;\n    margin-top: 0;\n    height: 70px;\n    width: 100%;\n  }\n}\n.left-drop {\n  .select__list {\n    right: auto;\n    left: 0;\n  }\n}\n.select__list.select__list--above {\n  bottom: 14px;\n  right: 0;\n  top: unset;\n}\n.selected_option {\n  background-color: rgba(66, 108, 166, 0.1843137255);\n}\ntextarea {\n  resize: none;\n  width: 330px;\n  height: 100%;\n  border: 1px solid #a3b9d998;\n  font-style: italic;\n  font-weight: 400;\n  font-size: 1rem;\n  // font-size: 0.9em;\n  // line-height: 13px;\n  color: #426ba6;\n  &:focus {\n    outline: none;\n    border: 1px solid #27336e6d;\n  }\n  &[readOnly] {\n    &:focus {\n      outline: none;\n      border: 1px solid #a3b9d998;\n    }\n  }\n}\n.textArea_label {\n  margin-bottom: 2px;\n  white-space: nowrap;\n}\n.inputWithMeasureUnits {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.readOnly {\n  input {\n    &:focus {\n      outline: none;\n      border-bottom: 1px solid #e2e2e2;\n    }\n  }\n}\ninput[readOnly] {\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid #e2e2e2;\n  }\n}\n\n#questionImg {\n  width: 1.2em;\n  height: 1.2em;\n  z-index: 99;\n  display: block;\n  position: relative;\n}\n.question {\n  margin-left: 4px;\n  position: relative;\n  display: inline-block;\n\n  &__dropdown {\n    position: absolute;\n    bottom: 20px;\n    // background-image: $bg-img;\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    min-width: 100px;\n    min-height: 10px;\n    background-color: transparent;\n    font-weight: 300;\n    margin-left: -45px;\n    p {\n      padding: 0 5px;\n      padding-bottom: 10px;\n    }\n  }\n}\n\n.procent {\n  display: flex;\n  align-items: flex-end;\n  justify-content: right;\n  // margin-left: 4px;\n  // position: relative;\n  // display: inline-block;\n  // position: relative;\n  &:after {\n    // margin-left: 4px;\n    // position: relative;\n    // display: inline-block;\n    content: \"%\";\n  }\n}\n\n.price_input {\n  display: flex;\n  //   flex-wrap: nowrap;\n\n  gap: 1em;\n  //   justify-content: space-between;\n  align-items: center;\n}\n\n.datePicker_withText {\n  position: relative;\n  display: flex;\n  // align-items: center;\n  height: 1.5em;\n  // width: 9em;\n  // width: 160px;\n  input {\n    // left: -100px;\n    // top: 0.3em;\n    color: #426ba6;\n    z-index: 2;\n    position: relative;\n    // width: 100px;\n    // height: 15px;\n    padding: 0;\n    // border: 0;\n    background-color: rgba(255, 255, 255, 0);\n    // &:focus {\n    //     outline: none;\n    //     // border-bottom: 0;\n    // }\n  }\n  input[type=\"date\"]::-webkit-calendar-picker-indicator {\n    opacity: 0;\n    // cursor: pointer;\n  }\n  .datePicker_img {\n    // left: -1.5em;\n    top: -0.3em;\n    right: -0.4em;\n    z-index: 99;\n    cursor: pointer;\n    position: absolute;\n  }\n}\n\n.question-date {\n  left: -1.5em;\n  top: 0;\n  z-index: 99;\n  cursor: pointer;\n  position: relative;\n}\n\n.miniLabel {\n  label {\n    width: 10px;\n  }\n}\n.additional_inputs {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 1em;\n  // width: 100%;\n  .project_input {\n    min-width: 50px;\n    // max-width: 70px;\n  }\n\n  label {\n    width: auto;\n  }\n}\n.closeInput {\n  label {\n    width: auto;\n    margin-right: 0.5em;\n  }\n}\n.question__dropdown {\n  font-size: smaller;\n}\n\ninput[type=\"checkbox\"] {\n  width: 1.2em;\n  height: 1.2em;\n}\n\n.doc__input_selected {\n  // outline: none;\n  border-bottom: 1px solid #1d265264;\n  // background-color:#426ca619;\n  // background: linear-gradient( transparent, 70%, #426ca621);\n  // background: radial-gradient(at 30% 100%, #426ca621 30%, transparent 70%);\n}\n\n.selectedFormRef {\n  .ref_input {\n    border-bottom: 1px solid #1d265264;\n  }\n}\n\n.autolabel {\n  .project_input label {\n    min-width: auto;\n    width: auto;\n  }\n}\n\n.project_input {\n  label.autolabel {\n    min-width: auto;\n    width: auto;\n  }\n}\n.leftLebel {\n  .error {\n    left: 0;\n  }\n}\n","$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$accentFilterColor: #ff8040;\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
